__webpack_require__.p = "/njkjzyxy/";